// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1i0Rx","validationTips":"StatementDescriptor_validationTips__1yBgK"};